import { render, staticRenderFns } from "./term_stages.vue?vue&type=template&id=789dd397&"
import script from "./term_stages.vue?vue&type=script&lang=js&"
export * from "./term_stages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports